import { Action } from '@ngrx/store';

export const GET_CURRENT_USER_PERMISSIONS_SUCCESS = '[Security] Get Current User Permissions Success';

export class GetCurrentUserPermissionsSuccessAction implements Action {
  readonly type = GET_CURRENT_USER_PERMISSIONS_SUCCESS;

  constructor(public payload: { permissions: string[] }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetCurrentUserPermissionsSuccessAction.ts